<template>
  <video-player v-if="showPlayer" :sources="sources"></video-player>
  <div v-else class="progress-wrapper is-flex" qa="video-upload-progress">
    <div>
      {{$t('videoInfo.waiting')}}...
      <br>
      {{ $t(`videoInfo.${this.action}`) }} {{ this.progress }}%
    </div>
  </div>
</template>

<script>
import VideoPlayer from './video-player'
import firebase from '@/libs/firebase'

export default {
  components: {
    VideoPlayer
  },
  props: ['attachment'],
  data: function () {
    return {
      showPlayer: false,
      action: 'processing',
      progress: 0
    }
  },
  mounted: function () {
    if (this.metadata.processingCompleted === true || this.metadata.processingComplete === true) {
      this.showPlayer = true
    } else {
      if (this.metadata.transactionId === undefined) {
        this.showPlayer = true
      } else {
        const that = this
        firebase.projectBoard.signIn().then(() => {
          const ref = firebase.database().ref(`progress/${this.metadata.transactionId}`)
          ref.on('value', function (data) {
            let task = ''
            data.forEach(function (childSnapshot) {
              if (childSnapshot.key === 'status') {
                task = childSnapshot.val()
                if (task === 'PREPARING') {
                  that.action = 'preparing'
                } else if (task === 'PROCESSING') {
                  that.action = 'processing'
                } else if (task === 'PROGRESSING') {
                  that.action = 'transcoding'
                }

                if (task === 'COMPLETE' || task === 'ERROR' || task === 'CANCELED') {
                  ref.off()
                  that.showPlayer = true
                  that.metadata.processingComplete = true
                }
              }
              if (childSnapshot.key === 'percentage') {
                that.progress = childSnapshot.val()
              }
            })
          }, function (error) {
            console.error(error)
          })
        })
      }
    }
  },
  computed: {
    sources: function () {
      return [{
        src: this.metadata.hls_url,
        type: 'application/x-mpegURL'
      }]
    },
    metadata: function () {
      return this.attachment.metadata ? this.attachment.metadata : {}
    },
    image: function () {
      return this.attachment.url
    }
  }
}
</script>

<style lang="scss" scoped>
  .columns {
    max-width: 100%;
    padding: 0.5rem;
    height: 100%;
    align-items: center;
  }

  .icon {
    display: block;
  }

  .media-content {
    margin-left: 1rem;
    p {
      padding-bottom: 0.6rem;
    }
  }

  .file{
    cursor: pointer;
    margin: 4rem 3rem;
  }

  .title {
    font-size: 1.1rem;
    font-weight: 700;
    line-height: 1.5rem;
  }
  .progress-text {
    margin: 1rem 0.25rem 0;
    padding: 0 4rem;
    text-align: center;
  }
  .progress-wrapper {
    height: 100%;
    align-items: center;
    div {
      text-align: center;
      color: white;
      font-weight: 700;
      background-color: #cecece;
      padding: 2rem;
      margin: 0 auto;
      border-radius: 5px;
    }
  }
</style>
